import { createContext } from 'react';

import { DateConfig } from './types';

export const DateConfigContext = createContext<DateConfig>({ adultAge: 18 });
